import { useState } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
} from "@mui/material";
import { MdAdd, MdDelete } from "react-icons/md";
import { Link } from "react-router-dom";
import {
  useGetPurchasesQuery,
  useRemovePurchaseMutation,
} from "../../features/api/purchaseApi";
import { toast } from "react-toastify";
import { useRemoveTransactionMutation } from "../../features/api/transactionApi";
import { formatDate } from "../../components/CommonDateFormat";

const Purchase = () => {
  const { data, isLoading } = useGetPurchasesQuery(null, {
    refetchOnMountOrArgChange: true,
  });

  const [removePurchase] = useRemovePurchaseMutation();
  const [removeTransaction] = useRemoveTransactionMutation();

  const handleDelete = async (id) => {
    const confirm = window.confirm("Are Your Sure?");
    if (confirm) {
      try {
        const result = await removePurchase(id);
        if (!result?.error) {
          await removeTransaction(id);
          toast.success("Delete Success..!!!");
        } else {
          toast.error(result?.error?.data?.error);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  // Search Term Start
  const [searchTerm, setInputValue] = useState("");
  const searchResults = data?.filter((option) => {
    if (option && typeof option === "object") {
      return Object.values(option).some((value) => {
        if (typeof value === "string") {
          return value.toLowerCase().includes(searchTerm.toLowerCase());
        } else {
          return String(value).toLowerCase().includes(searchTerm.toLowerCase());
        }
      });
    } else {
      return false;
    }
  });
  // Search Term End

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(30);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const commaForAmt = (number) => {
    return number ? new Intl.NumberFormat("en-IN").format(number) : 0;
  };

  return (
    <div className="px-12">
      <div className="flex justify-between items-center py-4">
        <h1 className="text-xl font-bold">Purchase</h1>
        <Link
          to="/dashboard/createPurchase"
          className="flex items-center p-1 text-white bg-blue-500 rounded"
        >
          {" "}
          <span className="  font-bold cursor-pointer">
            <MdAdd className="text-xl text-white bg-blue-500 " />
          </span>
          <span> New Purchase</span>
        </Link>
      </div>
      <input
        type="text"
        placeholder="Search items"
        className="border focus:outline-none h-10 w-[250px] mb-3 rounded p-1 bg-slate-50"
        value={searchTerm}
        onChange={(e) => setInputValue(e.target.value)}
      />
      <div className=" py-2">
        {isLoading ? (
          <div className="w-fll h-screen flex flex-col items-center justify-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
          </div>
        ) : data?.length === 0 ? (
          <p className=" text-xl text-red-500 mt-20 ml-20">
            There are no purchase item
          </p>
        ) : (
          <TableContainer
            component={Paper}
            // style={{ backgroundColor: "#f0f0f5" }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    SL No.
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    Purchase no.
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    Challan no.
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    Challan Date
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    Supplier
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    Total
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {searchResults
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  ?.map((row, i) => {
                    return (
                      <TableRow key={row?.id}>
                        <TableCell>{i + 1}</TableCell>
                        <TableCell>{row?.pu_no}</TableCell>
                        <TableCell>{row?.ch_no}</TableCell>
                        <TableCell>{formatDate(row?.ch_date)}</TableCell>
                        <TableCell>{row?.supplier}</TableCell>
                        <TableCell>{commaForAmt(row?.sub_total)}</TableCell>
                        <TableCell className="">
                          <div className="flex items-center gap-x-4">
                            <Link
                              to={`/dashboard/purchase-view/${row?.id}`}
                              className=" text-green-700 border border-green-700 px-1 py-0.5 rounded-sm font-bold cursor-pointer"
                            >
                              View
                            </Link>
                            {/* <Link
                              to="/dashboard/updatePurchase"
                              state={passData}
                            >
                              <span>
                                <FaEdit className="text-xl text-blue-500 font-bold cursor-pointer" />
                              </span>
                            </Link>
                            <span onClick={() => handleDelete(row?.ch_no)}>
                              <MdDelete className="text-xl text-red-500 font-bold cursor-pointer" />
                            </span> */}
                          </div>
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
            <TablePagination
              style={{ backgroundColor: "#f0f0f5" }}
              rowsPerPageOptions={[30, 50, 100]}
              component="div"
              count={data?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        )}
      </div>
    </div>
  );
};

export default Purchase;
